import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Header from './Header/Header'
import SearchPresentation from './SearchPresentation/SearchPresentation'
import ProjectDescriptions from './ProjectDescriptions/ProjectDescriptions'
import Presentations from './Presentations/Presentations'
import Statistics from './Statistics/Statistics'
import ProjectNotFound from './ProjectNotFound/ProjectNotFound'
import Loading from '../Loading/Loading'
import { projectService } from '../../services/apiRemote'
import './Project.css'

function Project() {
  const { projectId } = useParams()
  console.log(projectId)
  const [activeTab, setActiveTab] = useState('presentations')
  const [projectData, setProjectData] = useState(null)
  const [companyData, setCompanyData] = useState(null)
  const [descriptions, setDescriptions] = useState({})
  const [presentations, setPresentations] = useState({})
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  console.log(projectId)

  useEffect(() => {
    const fetchProjectData = async () => {
      try {
        setLoading(true)
        // Fetch project data
        const projectData = await projectService.getProjectById(projectId)
        if (!projectData) {
          setError('Project not found')
          setLoading(false)
          return
        }
        setProjectData(projectData)

        // Fetch company data
        const companyData = await projectService.getCompanyById(projectData.company_id)
        if (!companyData) {
          setError('Company not found')
          setLoading(false)
          return
        }
        setCompanyData(companyData)

        // Fetch descriptions
        const descriptionsData = await projectService.getProjectDescriptions(projectId)
        setDescriptions(descriptionsData)

        // Fetch presentations
        const presentationsData = await projectService.getProjectPresentations(projectId)
        setPresentations(presentationsData)

        setLoading(false)
      } catch (err) {
        setError(err.message)
        setLoading(false)
      }
    }

    fetchProjectData()
  }, [projectId])

  const handleTabChange = (tab) => {
    setActiveTab(tab)
  }

  if (loading) return <Loading />
  if (error === 'Project not found') return <ProjectNotFound />
  if (error) return <div>Error: {error}</div>
  if (!projectData || !companyData) return <div>Project or company data not found</div>

  return (
    <>
      <Header project={projectData} company={companyData} />
      <ProjectDescriptions descriptions={descriptions} />
      {/* <SearchPresentation /> */}
      <div className="switcherWrapper">
        <button 
          className={`descriptionIntro ${activeTab === 'presentations' ? 'activeBtn' : ''}`}
          onClick={() => handleTabChange('presentations')}
        >
          Presentations ({Object.keys(presentations).length})
        </button>
        <button 
          className={`statistics ${activeTab === 'statistics' ? 'activeBtn' : ''}`}
          onClick={() => handleTabChange('statistics')}
        >
          Statistics (2)
        </button>
      
      </div>
      {activeTab === 'presentations' && <Presentations presentations={presentations} />}
      {activeTab === 'statistics' && <Statistics />}
    </>
  )
}

export default Project